import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import sceneExtract from "./../../images/scene_extract_logo.png";
import kpitLogo from "./../../images/kpit_logo_new.png";

class SimulibNavbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      toggleState: false,
      passengerData: {},
      commercialData: {},
    };
  }

  render() {
    return (
      <nav
        className="navbar navbar-expand-lg navbar-light bg-light"
        style={{ padding: "0px" }}
      >
        <li
          className="navbar-brand"
          href="#"
          style={{ paddingLeft: "1%", margin: "0", paddingRight: "1%" }}
        >
          <Link style={{ textDecoration: "none" }} to="/navigate_new">
            <img src={kpitLogo} alt="" height="30" />
          </Link>
        </li>
        <li className="navbar-brand" href="#">
          <Link to="/event_analyzer_filtering">
            <img
              src={sceneExtract}
              width="175"
              height="40"
              className="d-inline-block align-top"
              alt=""
              style={{ paddingLeft: "5%" }}
            ></img>
          </Link>
        </li>
        <li
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNavDropdown"
          aria-controls="navbarNavDropdown"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </li>
        <div className="collapse navbar-collapse" id="navbarNavDropdown">
          <div className="collapse navbar-collapse">
            <div className="navbar-nav mx-auto">
              <li
                className="navbar-brand"
                href="#"
                style={{ padding: "0px" }}
              ></li>
            </div>
            <ul className="navbar-nav">
              <li className="nav-item dropdown">
                <li
                  className="nav-link dropdown-toggle"
                  href="#"
                  id="navbarDropdownMenuLink"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i className="fas fa-user-lock"></i>
                </li>
                <div
                  className="dropdown-menu dropdown-menu-right"
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  <li className="dropdown-item" href="#">
                    <Link
                      to="/event_analyzer_filtering"
                      style={{ textDecoration: "none", color: "#464646" }}
                    >
                      Scene Extract
                    </Link>
                  </li>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    );
  }
}

SimulibNavbar.defaultProps = {
  passengerData: {},
  commercialData: {},
  logOut: () => {
    console.log("Logged Out");
  },
};

const mapStateToProps = (state) => {
  return {
    type: state.toggleState.text,
    toggleImage: state.toggleState.toggleImagePath,
  };
};
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

export default connect(mapStateToProps)(SimulibNavbar);
